import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; // Додадете го Firestore
import { getFunctions } from "firebase/functions"; // ✅ Додадено

const firebaseConfig = {
  apiKey: "AIzaSyDKjlyuf0-6oWCq9IuIO8AhbugRtCIVTv8",
  authDomain: "auto-makedonija.firebaseapp.com",
  projectId: "auto-makedonija",
  storageBucket: "auto-makedonija.firebasestorage.app",
  messagingSenderId: "999306061895",
  appId: "1:999306061895:web:ee5ee6e05c531f3dd0a962"
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const auth = getAuth(app);
const db = getFirestore(app); // Иницијализација на Firestore
const functions = getFunctions(app, 'us-central1'); // ✅ Иницијализација на Cloud Functions со регија

export { auth, storage, db, functions }; // ✅ Експортирање на functions
